import { Fragment, useEffect, useState } from "react";
import StoreItem from "./StoreItem";
import classes from "./StoreItem.module.css";
import { DUMMY_DATA } from "../../productStore";
import Pagination from "../Layout/pagination";
import Slide from "react-reveal/Slide";

const Store = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(8);

  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;

  const currentPost = DUMMY_DATA.slice(firstPostIndex, lastPostIndex);

  return (
    <Fragment>
      <main className="main">
        <h1>All Products</h1>
        <hr />
        <div className={classes.sales}>Black Friday Sales Is Here!</div>
        <hr />
        <Slide bottom>
          <ul id="small" className={classes.list}>
            {currentPost.map((product) => (
              <StoreItem product={product} />
            ))}
          </ul>
        </Slide>
        <Slide bottom>
          <ul id="large" className={classes.list}>
            {currentPost.map((product) => (
              <StoreItem product={product} />
            ))}
          </ul>
        </Slide>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPost={DUMMY_DATA.length}
          postPerPage={postPerPage}
        />
      </main>
    </Fragment>
  );
};

export default Store;
